import groupsModel from '@/models/groups/groups';

const actions = {
    getGroups({}, params) {
        return groupsModel.getPaginate(params)
    },
}

export default actions;